import axios, { AxiosInstance, AxiosPromise } from 'axios';
import { appURLS } from 'appRoot/app.constants';
import { ICalculatePaymentResult, IResponse } from 'shared-types/SharedTypes';
import NetworkRequestsService from 'external-services/network-requests-service';

const NS = 'PreAuthService';
const api: AxiosInstance = NetworkRequestsService.getGlobalAPI();
class PreAuthService {

  public charge(
    venueId: number,
    bookingId: string,
    customerId: string,
    chargingAmount: number
  ): AxiosPromise<any> {
    const data = {
      venueId,
      bookingId,
      customerId,
      chargingAmount,
    };

    return api.post(appURLS.API + '/restaurants/payments/preauth', data, {}) as AxiosPromise<
      IResponse<unknown>
    >;
  }
}

const instance = new PreAuthService();
export default instance as PreAuthService;
